import React from 'react';
import { Box, Typography, Stack, TextField, Autocomplete } from '@mui/material';
import type { PayerType } from '../../../../../../services/ConfigurationService/types/payerType';

interface BasicInfoSectionProps {
  priority: number;
  selectedPayer: PayerType | null;
  payerCode: string;
  payerName: string;
  payers: PayerType[];
  isDisabled: boolean;
  onPayerChange: (payer: PayerType | null) => void;
}

export const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  priority,
  selectedPayer,
  payerCode,
  payerName,
  payers,
  isDisabled,
  onPayerChange
}) => {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
        Basic Information
      </Typography>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <TextField
            label="Priority"
            type="number"
            size="small"
            value={priority}
            sx={{ width: 120 }}
            required
            helperText="Use grid arrows to reorder"
            InputProps={{ readOnly: true }}
            disabled
          />
          <Autocomplete
            options={payers}
            getOptionLabel={(option) => `${option.payerCode} - ${option.payerName}`}
            value={selectedPayer}
            onChange={(_, newValue) => onPayerChange(newValue)}
            disabled={isDisabled}
            sx={{ flex: 1 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Payer"
                size="small"
                placeholder="Select a payer..."
                required
                sx={{
                  '& .MuiInputBase-input': {
                    backgroundColor: isDisabled ? '#f5f5f5' : 'inherit'
                  }
                }}
                helperText={isDisabled ? 'Read-only (Encounter Cancelled)' : ''}
              />
            )}
          />
        </Stack>
        <Stack direction="row" spacing={2}>
          <TextField
            label="Payer Code"
            size="small"
            value={payerCode}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
            helperText="Auto-filled from payer selection"
            disabled
          />
          <TextField
            label="Payer Name"
            size="small"
            value={payerName}
            sx={{ flex: 2 }}
            InputProps={{ readOnly: true }}
            helperText="Auto-filled from payer selection"
            disabled
          />
        </Stack>
      </Stack>
    </Box>
  );
};
